import React from 'react';
import { Link } from 'react-router-dom';

export type AgreementNoticeMode = 'signin' | 'signup';

interface AgreementNoticeProps {
  mode?: AgreementNoticeMode;
}

export default function AgreementNotice({
  mode = 'signin',
}: AgreementNoticeProps) {
  return (
    <p className="text-xs text-gray-600">
      By signing {mode === 'signup' ? 'up' : 'in'}, you agree to Tapt's{' '}
      <Link to="/terms-of-service" target="_blank" className="text-xs">
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link to="/privacy-policy" target="_blank" className="text-xs">
        Privacy Policy
      </Link>
    </p>
  );
}
